export class ImagenFalla {
    id_imagen    : number;
    id_falla     : number;
    id_falla_detalle : number;
    imagenBase64 : string;
}
export class Uploadfile{
    id_file     :  number;
    nameFile    :  string;
    base64      :  string;
}